<template>
  <div>
    <v-btn :color="ui.btnColor" flat dark @click="openDialog()"
    v-if="licenceOK">
      <v-icon left>
        account_balance
      </v-icon>
      New
    </v-btn>
    <LicenceCard v-else
    :data="{
      title: 'Company',
      icon: 'warning',
      colorTitle: this.ui.textSubheadingBoldWarning,
      colorIcon: this.ui.colorWarning}"
    />
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Company
              </div>
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.name"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="title"
                  hint="company full legal name as per abr"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.abn"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="pin"
                  hint="abn as per abr"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.acn"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="confirmation_number"
                  hint="acn as per abr (if applicable)"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.struct"
                    :items="companyStructure"
                    color="wplblue0"
                    prepend-icon="account_tree"
                    hint="business structure"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.area"
                    :items="companyArea"
                    color="wplblue0"
                    prepend-icon="factory"
                    hint="business area"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.state"
                    :items="locationState"
                    color="wplblue0"
                    prepend-icon="image"
                    hint="state"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container :class="ui.bkgdColor" v-if="this.step == 3">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_balance </v-icon>
                  </v-avatar>
                  Name
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_balance </v-icon>
                  </v-avatar>
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> pin </v-icon>
                  </v-avatar>
                  ABN
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.abn}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> confirmation_number </v-icon>
                  </v-avatar>
                  ACN
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.acn}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_tree </v-icon>
                  </v-avatar>
                  Structure
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.struct}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> factory </v-icon>
                  </v-avatar>
                  Industry
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.area}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> image </v-icon>
                  </v-avatar>
                  State
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.state}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> verified_user </v-icon>
                  </v-avatar>
                  Company  Verificaton Process
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  New company approval requires verification by Besea. All requests should have a valid Australian Business Number (ABN). We may contact you to seek additional information to assist with company approval process.
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> admin_panel_settings </v-icon>
                  </v-avatar>
                  Company User Data Privacy
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  As Company Custodian you agree to follow Data Privacy Policy when processing personal data for new users who may seek access to your company data.
              </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> sync_alt </v-icon>
                  </v-avatar>
                  Company Data Sharing
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  As Company Custodian you agree that your company authenticated users will share, create and change your company data in accordance with authority level granted by you.              </div>
              </v-layout>
            </v-container>
          </v-form>

        </v-card-text>

        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            <v-icon left> navigate_next </v-icon>
            Next
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          class="hidden-sm-and-up"
          @click="nextStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid" v-if="enableSubmit"
          class="hidden-xs-only"
          @click="createNewCompany()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid" v-if="enableSubmit"
          class="hidden-sm-and-up"
          @click="createNewCompany()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import selectCompany from "@/data/options/mixins/selectCompany.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import selectLocation from "@/data/options/mixins/selectLocation.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import LicenceCard from "@/admin/licence/components/LicenceCard";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin,
    LicenceCard
  },
  // eslint-disable-next-line
  mixins: [
    licenceFunctions,
    adminFunctions,
    docRevsModFunctions,
    docLogFunctions,
    apptheme,
    ruleTextfield,
    selectCompany,
    storeFunctions,
    changeDetail,
    generateID,
    generateForms,
    accessFunctions,
    createFirebase,
    selectLocation
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        abn: "",
        acn: "",
        name: "",
        struct: "",
        area: "",
        state: ""
      },
      info: [
        {
          step: 0,
          title: "Company Setup",
          // eslint-disable-next-line
          msg: "Company is the foundation of business operations which manages company policies, procedures, budgets and strategic plans. The company is essential to create new facility and management of facility register.",
          icon: ""
        },
        {
          step: 1,
          title: "Critical Business Info",
          // eslint-disable-next-line
          msg: "Company legal name and abn must be in full as per the Australian Securities and Investments Commission (ASIC) or the Australian Business Register (ABR). Refer to business name check at business.gov.au if unsure. Complete all company details in full and press next.",
          icon: ""
        },
        {
          step: 2,
          title: "Define Structure and Industry",
          // eslint-disable-next-line
          msg: "The business structure identifies how you operate as a trading business in a particular industry. The selection should be as per the Austrlain Business definitions, refer to business.gov.au. Select company area, structure and state, then press next.",
          error: "Recheck the first and last name, as they do not match",
          icon: ""
        },
        {
          step: 3,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify entered information, reminder that entered data must be the company's full legal name in full as per the Australian Securities and Investments Commission (ASIC) or Australian Business Register (ABR). Admin will verify your request and activate the company.",
          error: "Recheck the first and last name, as they do not match",
          icon: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
    stepInfo() {
      return this.info[this.step];
    },
    enableSubmit() {
      let logic = false;
      if (this.step === 3 && this.btnSpinChangeDetail === false) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (this.step == 0) {
        logic = true;
      } else if (
        this.step == 1 &&
        this.localForm.name !== "" &&
        this.localForm.abn !== ""
      ) {
        logic = true;
      } else if (
        this.step == 2 &&
        this.localForm.busSruct !== "" &&
        this.localForm.area !== "" &&
        this.localForm.state !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createNewCompany() {
      this.btnSpinChangeDetail = true;
      // SET data source
      const tag = "C1";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");

      // GENERATE form
      let temp = this.generateCompanyForm(); // form is from compnew component

      // BASIC
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.tag = tag;
      temp.basic.act = false; // set company as not approved
      temp.basic.title = this.localForm.name;
      temp.basic.id = this.localForm.abn;

      // CHAR
      temp.char.name = this.localForm.name;
      temp.char.abn = this.localForm.abn;
      temp.char.acn = this.localForm.acn;
      temp.char.struct = this.localForm.struct;
      temp.char.area = this.localForm.area;
      temp.char.lstate = this.localForm.state;

      // STATS
      temp.stats.dcrt = moment().format();

      // REV
      temp.rev = this.generateInitialDocumentRev(tag);

      // RELPS - REMOTE
      // let relps = this.generateInitialRelationships(tag);
      // temp.relps = relps;

      // HELP
      // console.log("NEW COMPANY");
      // console.log(temp);
      // console.log(temp.basic.tag);

      // UPDATE USER STATS
      let udid = this.getUser.basic.did;
      this.changeFirebaseStatsRemote("U1", udid, "stats.nc1", 1);
      // CREATE DOC + ACCESS + USER LOG
      this.createFirebaseDocument(temp);
    }
  }
};
</script>
